export function isInViewport(innerElement: DOMRect, outerElement: DOMRect) {
    const { bottom, height, top } = innerElement;

    return top <= outerElement.top
        ? outerElement.top - top <= height
        : bottom - outerElement.bottom <= height;
}
